import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'redpoints-front-components/index';
import {
  withContext,
  withQueryParams,
} from 'redpoints-front-common/components';
import { redirect } from 'redpoints-front-common/helpers';

import {
  facilitatorValidationClearFilters,
  facilitatorValidationFetchNext,
} from '../../../actions/facilitatorValidationActions';
import {
  getFacilitatorValidationLinkTaskRequestIsLoading,
  getFacilitatorValidationSelectedDomainId,
  getFacilitatorValidationSelectedFilterByCustomer,
} from '../../../reducers/tasks/facilitatorValidation';
import { ROUTES } from '../../../config/constants';
import { translate } from '../../../helpers/languageHelper';

const FacilitatorValidationFiltersActions = ({
  customer: { customerId },
  domainId,
  facilitatorValidationClearFilters,
  facilitatorValidationFetchNext,
  filterByCustomer,
  isLoading,
  queryParams,
}) => {
  const customerIdToFetch = filterByCustomer ? customerId : undefined;

  const handleApply = () => {
    facilitatorValidationFetchNext({
      domainId,
      customerId: customerIdToFetch,
    });

    redirect({
      queryParams: { domainId, filterByCustomer },
      urlRoute: ROUTES.FACILITATOR_VALIDATION,
    });
  };

  const handleClear = () => {
    facilitatorValidationClearFilters();

    redirect({ urlRoute: ROUTES.FACILITATOR_VALIDATION });
  };

  const applyButtonDisabled =
    isLoading ||
    (queryParams.domainId === domainId?.toString() &&
      queryParams.filterByCustomer === filterByCustomer?.toString());

  return (
    <>
      <Button
        aria-label="button-apply"
        className="ant-btn-sm"
        disabled={applyButtonDisabled}
        onClick={handleApply}
        type="primary"
      >
        {translate('actions.apply')}
      </Button>
      <Button
        aria-label="button-clear"
        className="ant-btn-sm"
        disabled={isLoading}
        onClick={handleClear}
        type="secondary"
      >
        {translate('actions.clear')}
      </Button>
    </>
  );
};

const mapStateToProps = state => ({
  domainId: getFacilitatorValidationSelectedDomainId(state),
  filterByCustomer: getFacilitatorValidationSelectedFilterByCustomer(state),
  isLoading: getFacilitatorValidationLinkTaskRequestIsLoading(state),
});

export default compose(
  withContext,
  withQueryParams,
  connect(mapStateToProps, {
    facilitatorValidationClearFilters,
    facilitatorValidationFetchNext,
  })
)(FacilitatorValidationFiltersActions);
